'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _strings = require('helpers/strings');

var _projects = require('helpers/projects');

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SharespacePublishButton.scss');

var SharespacePublishButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    projectLoaded: state.project.projectLoaded,
    publishSharespaceLoaded: state.project.publishSharespaceLoaded,
    publishSharespaceLoading: state.project.publishSharespaceLoading,
    suspendSharespaceLoaded: state.project.suspendSharespaceLoaded,
    suspendSharespaceLoading: state.project.suspendSharespaceLoading,
    teamMembersListData: state.project.teamMembersListData
  };
}, (0, _extends3.default)({}, projectActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SharespacePublishButton, _Component);

  function SharespacePublishButton() {
    (0, _classCallCheck3.default)(this, SharespacePublishButton);
    return (0, _possibleConstructorReturn3.default)(this, (SharespacePublishButton.__proto__ || (0, _getPrototypeOf2.default)(SharespacePublishButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(SharespacePublishButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadTeamMembers();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.project !== this.props.project) {
        this.loadTeamMembers();
      }
    }
  }, {
    key: 'loadTeamMembers',
    value: function loadTeamMembers() {
      var _props = this.props,
          project = _props.project,
          loadTeamMembers = _props.loadTeamMembers;

      if ((0, _get3.default)(project, 'id')) {
        loadTeamMembers(project.id);
      }
    }
  }, {
    key: 'publishSharespace',
    value: function publishSharespace() {
      var _props2 = this.props,
          publishSharespace = _props2.publishSharespace,
          project = _props2.project;

      return publishSharespace(project.id);
    }
  }, {
    key: 'suspendSharespace',
    value: function suspendSharespace() {
      var _props3 = this.props,
          suspendSharespace = _props3.suspendSharespace,
          project = _props3.project;

      return suspendSharespace(project.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          className = _props4.className,
          project = _props4.project,
          publishSharespaceLoading = _props4.publishSharespaceLoading,
          publishSharespaceLoaded = _props4.publishSharespaceLoaded,
          suspendSharespaceLoading = _props4.suspendSharespaceLoading,
          suspendSharespaceLoaded = _props4.suspendSharespaceLoaded,
          projectLoaded = _props4.projectLoaded,
          teamMembersListData = _props4.teamMembersListData;
      var t = this.context.t;

      var isPublished = (0, _get3.default)(project, 'status') === _projects.projectStatus.published && !suspendSharespaceLoaded || publishSharespaceLoaded;

      if (!projectLoaded) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className, styles.container) },
        isPublished ? _react2.default.createElement(
          'div',
          null,
          publishSharespaceLoaded ? _react2.default.createElement(
            'div',
            { className: 'margin-bottom-20' },
            _react2.default.createElement(
              'p',
              null,
              t('Done!')
            ),
            _react2.default.createElement(
              'p',
              null,
              t('Your Sharespace is now available to create projects. The following team members have been notified:')
            ),
            teamMembersListData.map(function (member) {
              return _react2.default.createElement(
                'div',
                null,
                '\u2022 ',
                (0, _strings.concat)(' ', member.name, member.surname),
                ' (',
                member.userEmail,
                ')'
              );
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'margin-vert-20' },
            t('By clicking on the Suspend button below, team members will NO LONGER have access to this sharespace.\n                 Existing projects created from this sharespace will remain active.')
          ),
          _react2.default.createElement(
            _Button2.default,
            {
              className: 'btn-danger wide margin-vert-5 pull-right',
              onClick: this.suspendSharespace,
              loading: suspendSharespaceLoading
            },
            t('Suspend'),
            '!'
          )
        ) : _react2.default.createElement(
          'div',
          null,
          suspendSharespaceLoaded && _react2.default.createElement(
            'div',
            { className: 'margin-bottom-20' },
            _react2.default.createElement(
              'p',
              null,
              t('Your Workspace is not available for team members to use.')
            ),
            _react2.default.createElement(
              'p',
              null,
              t('However, already created projects are still available to their recipients.')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-vert-20' },
            t('By clicking on the Publish button below, team members will have access to this sharespace.\n               Until you publish this Sharespace no-one can access it.')
          ),
          _react2.default.createElement(
            _Button2.default,
            {
              className: 'btn-primary wide margin-vert-5 pull-right',
              onClick: this.publishSharespace,
              loading: publishSharespaceLoading
            },
            t('Publish')
          )
        )
      );
    }
  }]);
  return SharespacePublishButton;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  loadTeamMembers: _propTypes2.default.func,
  project: _propTypes2.default.object,
  projectLoaded: _propTypes2.default.bool,
  publishSharespace: _propTypes2.default.func,
  publishSharespaceLoaded: _propTypes2.default.bool,
  publishSharespaceLoading: _propTypes2.default.bool,
  suspendSharespace: _propTypes2.default.func,
  suspendSharespaceLoaded: _propTypes2.default.bool,
  suspendSharespaceLoading: _propTypes2.default.bool,
  teamMembersListData: _propTypes2.default.array
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  project: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'publishSharespace', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publishSharespace'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'suspendSharespace', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'suspendSharespace'), _class2.prototype)), _class2)) || _class);
exports.default = SharespacePublishButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/SharespacePublishButton/SharespacePublishButton.js
// module id = 865
// module chunks = 1